<script>
export default {
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        index: Number
    },
    name: "mineOption",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        // 选中
        choose() { 
            // console.log(this.$parent)
            if (this.$parent) { 
                this.$parent.$data.isActive = false;
                this.$parent.tapDom();
                this.$emit('click');
            }
        },
    },
};
</script>

<template>
    <div class="mine_option" :class="{active: isActive}" @click="choose" :title="$slots.default ? $slots.default[0].text : ''"><slot></slot></div>
</template>

<style scoped lang="scss">
.mine_option{
    padding: 0 .1rem;
    height: .35rem;
    cursor: pointer;
    line-height: .35rem;
    cursor: pointer;
    // 溢出隐藏
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    @media screen and (max-width: 750px) {
        height: .6rem;
        line-height: .6rem;
        padding: 0 .3rem;
        text-align: center;
    }
    &.active,
    &:hover{
        background: #f1f1f1;
        @media screen and (max-width: 750px) {
            background: none;
        }
    }
    &.active{
        @media screen and (max-width: 750px) {
            background: #fff;
        }
    }
}
</style>